// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23ao2","colMin":"styles_colMin__389T2"};